export { CustomerAddressQueryWrapper } from './src/customer-address-query-wrapper';
export { getCustomerAddressWidgetContent } from './src/customer-address-widget-context';
export type { CustomerAddressQueryItem } from './src/customer-address-query-wrapper';
